import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { MemberPaths } from "src/app/constants/routes";
import { BenefitRequests } from "src/app/models/benefit-requests";
import { EnrollmentDashboardService } from "src/app/services/enrollment-dashboard.service";
import { EnrollmentOnboardService } from "src/app/services/enrollment-onboard.service";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";
import { OnboardingEnrollmentsItem } from 'src/app/models/enrollment-onboard';

@Component({
    selector: "mwp-benefit-change-request",
    templateUrl: "./benefit-change-request.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class BenefitChangeRequestComponent implements OnInit {

    public apiUrl = ContentHeaderKey.EnrollmentBenefitRequests;
    public benefitRequests: BenefitRequests = null;
    public displayHSA: boolean;
    public displayVoluntaryTerm: boolean;
    public displayRetirement: boolean;
    public displayNoRequests: boolean;
    public noRequestsMessage: string;
    public isLoading: boolean = true;
    public isDynamicErrorMessage: boolean = false;
    public jsonKeyPrefix: string = 'benefitRequests';
    public jsonKey: string;

    constructor(
        private enrollmentDashboardService: EnrollmentDashboardService,
        private enrollmentOnboardService: EnrollmentOnboardService,
        private enrollmentManagerService: EnrollmentManagerService,
        private router: Router,
    ) {
    }

    ngOnInit(): void {
        this.noRequestsMessage = 'There are no Benefit Requests you can make at this time.';

        this.enrollmentDashboardService.getBenefitChangeRequests().subscribe((response: BenefitRequests) => {
            if (response.hasError) {
                this.displayNoRequests = true;
                this.isDynamicErrorMessage = true;
                this.noRequestsMessage = response.errorMessage;
                this.jsonKey = `${this.jsonKeyPrefix}${response.errorMessage}`;
                this.isLoading = false;
            } else {
                this.displayHSA = response.hsaBenefitRequests?.length > 0;
                this.displayVoluntaryTerm = response.voluntaryTermBenefitRequests?.length > 0;
                this.displayRetirement = response.retirementBenefitRequests?.length > 0;
                this.displayNoRequests = !this.displayHSA && !this.displayVoluntaryTerm && !this.displayRetirement;
                this.benefitRequests = response;
                this.isLoading = false;
            }
        });
    }

    public intializeEnrollment(id: number): void {
        this.enrollmentOnboardService.enrollYearRoundOptionId = id;
        this.enrollmentOnboardService.autoOnboardingQleBenefitRequest().subscribe((response: OnboardingEnrollmentsItem) => {
            this.enrollmentManagerService.setEnrollmentMode(response);
            this.router.navigateByUrl(MemberPaths.BenefitEnrollment);
        });
    }
}
